import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
// import Layout from '../../../components/Layout/MembersPortalLayout/MembersPortalLayout';
import { Payment } from '@mui/icons-material';

import mayaLogo from '../../../assets/maya_logo.png';
import mayaB from '../../../assets/maya-b.png';
import mayaPayment from '../../../assets/koop-payment.png';

const PaymentPage: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const location = useLocation();
    const { state } = location as { state: { id: number } };

    const handlePayment = () => {
        // Implement your payment logic here
        console.log('Payment processed');
        // Navigate to another page after payment, if needed
        navigate('/Members/LoanStatus');
    };

    return (
        <div className="payment-container">
            <div className='payment-header'>
                <div>
                    <span>You are paying</span><br />
                    Paymongo Test
                </div>
                <div>
                    <span>Payment No.</span><br />
                    {location.state.loanTermAmortizationId}
                </div>
            </div>
            <img src={mayaPayment} className='payment-body' onClick={() => navigate(-1)} />
            <div className='payment-footer'><img src={mayaB} className='payment-logo' /></div>
        </div >
    );
};

export default PaymentPage; 